import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment-timezone';
import { Row, Col } from 'react-grid-system';
import { getLocalizedText } from '@vp-dst/localization-util';

import { defaultTextStyle } from 'settings/theme';
import Loader from 'components/vistaprintUILibrary/Loader';
import Button from 'components/vistaprintUILibrary/Button';
import ErrorMessage from 'components/vistaprintUILibrary/ErrorMessage';
import OptionSet from 'components/vistaprintUILibrary/OptionSet';

function TimeOptions(props) {
    const {
        heading,
        timeStrings,
        selectedTimezone,
        selectedTimeString,
        selectedTimeOnChange,
        timeOfDay, // tracking
    } = props;

    return (
        <div>
            <div
                style={{
                    ...defaultTextStyle,
                    fontSize: '1.3em',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    marginTop: 20,
                }}
            >
                {heading}
            </div>
            <hr />
            <div
                style={{
                    marginTop: 15,
                }}
            >
                {timeStrings.length === 0 &&
                    <div
                        style={{
                            ...defaultTextStyle,
                        }}
                    >
                        {getLocalizedText('no-available-times')}
                    </div>
                }
                <OptionSet
                    name={heading.split(' ').join('')}
                    options={timeStrings.map(timeString => {
                        const time = moment(timeString).tz(selectedTimezone);

                        return {
                            value: timeString,
                            text: time.format("LT") + " - " + time.add(30, "minutes").format("LT"),
                            selected: timeString === selectedTimeString,
                        };
                    })}
                    onChange={(event) => selectedTimeOnChange(event, timeOfDay)}
                />

            </div>
        </div>
    );
}

class TimeSelect extends React.Component {
    render() {
        const {
            loading,
            errorMessage,
            refreshAvailableTimes,
            availableTimes,
            selectedTimezone,
            selectedTime,
            selectedTimeOnChange,
        } = this.props;

        if (loading) {
            return (<Loader text={getLocalizedText('loading-available-times')} />);
        }

        if (errorMessage) {
            return (
                <div
                    style={{
                        paddingTop: 20,
                        paddingBottom: 20,

                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <ErrorMessage containerStyle={{ textAlign: 'center' }} text={errorMessage} />
                    <Button
                        text={getLocalizedText('refresh-times')}
                        type="secondary"
                        onClick={refreshAvailableTimes}
                    />
                </div>
            );
        }

        if (availableTimes.length === 0) {
            return (
                <div
                    style={{
                        ...defaultTextStyle,
                        fontSize: '1.3em',
                        textAlign: 'center',
                        paddingTop: 40,
                    }}
                >
                    {getLocalizedText('sorry-no-times-available')}
                </div>
            );
        }

        const morningTimes = availableTimes.filter((timeString) => {
            const time = moment(timeString).tz(selectedTimezone);
            return parseInt(time.format("H"), 10) < 12;
        });

        const afternoonTimes = availableTimes.filter((timeString) => {
            const time = moment(timeString).tz(selectedTimezone);
            return parseInt(time.format("H"), 10) >= 12 && time.format("H") < 17;
        });

        const eveningTimes = availableTimes.filter((timeString) => {
            const time = moment(timeString).tz(selectedTimezone);
            return parseInt(time.format("H"), 10) >= 17;
        });

        return (
            <Row>
                <Col xs={12} md={4}>
                    <TimeOptions
                        heading={getLocalizedText('morning')}
                        timeStrings={morningTimes}
                        selectedTimezone={selectedTimezone}
                        selectedTimeString={selectedTime}
                        selectedTimeOnChange={selectedTimeOnChange}
                        timeOfDay="morning" // tracking (string must be exact)
                    />
                </Col>
                <Col xs={12} md={4}>
                    <TimeOptions
                        heading={getLocalizedText('afternoon')}
                        timeStrings={afternoonTimes}
                        selectedTimezone={selectedTimezone}
                        selectedTimeString={selectedTime}
                        selectedTimeOnChange={selectedTimeOnChange}
                        timeOfDay="afternoon" // tracking (string must be exact)
                    />
                </Col>
                <Col xs={12} md={4}>
                    <TimeOptions
                        heading={getLocalizedText('evening')}
                        timeStrings={eveningTimes}
                        selectedTimezone={selectedTimezone}
                        selectedTimeString={selectedTime}
                        selectedTimeOnChange={selectedTimeOnChange}
                        timeOfDay="evening" // tracking (string must be exact)
                    />
                </Col>
            </Row>
        );
    }
}

TimeSelect.propTypes = {
    timezone: PropTypes.string,
    availableTimes: PropTypes.arrayOf(PropTypes.string),
    handleTimeSelection: PropTypes.func
}

export default TimeSelect;


// WEBPACK FOOTER //
// ./src/components/Scheduler/TimeSelect.js